export enum AssetType {
  logo = 'logo',
  question_image = 'question_image',
  question_audio = 'question_audio',
  question_video = 'question_video',
  certificate = 'certificate',
  users_import = 'users_import',
  exam_book = 'exam_book',
}

export enum ContentType {
  binary = 'binary/octet-stream',
  csv = 'text/csv',
  gif = 'image/gif',
  jpeg = 'image/jpeg',
  jpg = 'image/jpeg',
  mp3 = 'audio/mpeg',
  mp4 = 'video/mp4',
  png = 'image/png',
  pdf = 'application/pdf',
}

export function parseContentType(file: File): string {
  const extension = file.name.split('.').pop() as string;

  let type: string;

  switch (extension.toLowerCase()) {
    case 'jpeg':
    case 'jpg':
      type = ContentType.jpg;
      break;
    case 'png':
      type = ContentType.png;
      break;
    case 'gif':
      type = ContentType.gif;
      break;
    case 'csv':
      type = ContentType.csv;
      break;
    case 'mp3':
      return ContentType.mp3;
    case 'mp4':
      return ContentType.mp4;
    case 'pdf':
      return ContentType.pdf;
    default:
      type = ContentType.binary;
      break;
  }


  return type;
}

export class Asset {
  public type: AssetType;
  public uploadUrl?: string;
  public url?: string;

  constructor(type: AssetType) {
    this.type = type;
  }

  public static parse(data: UploadAsset): Asset {
    const asset = new Asset(data.type);

    asset.uploadUrl = data.upload_url;
    asset.url = data.url;

    return asset;
  }
}

export interface UploadAsset {
  type: AssetType;
  name?: string;
  content_type?: ContentType | string;
  upload_url?: string;
  url?: string;
}
